import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// v1.1.0 · Web pública rediseñada
import SiteLanding from "./components/site/SiteLanding";

// Pages
import CheckoutPage from "./pages/CheckoutPage";
import TransferPage from "./pages/TransferPage";
import LoginPage from "./pages/LoginPage";
import FinanzasPage from "./pages/FinanzasPage";
import FinanzasPagosPage from "./pages/FinanzasPagosPage";
import ContratosPage from "./pages/ContratosPage";
import FirmarContratoPage from "./pages/FirmarContratoPage";
import CustomerPage from "./pages/CustomerPage";
import PayphonePage from "./pages/PayphonePage";
import PayphoneConfirmacionPage from "./pages/PayphoneConfirmacionPage";
import MercadoPage from "./pages/MercadoPage";
import UsuariosPage from "./pages/UsuariosPage";
import QAPage from "./pages/QAPage";
import FirmarActaPage from "./pages/FirmarActaPage";
import EmailConfigPage from "./pages/EmailConfigPage";
import ComprasPage from "./pages/ComprasPage";
import ContabilidadPage from "./pages/ContabilidadPage";
import CrmPage from "./pages/crm/CrmPage";   // v1.7.0 · CRM fase 1
import BookingPage from "./pages/BookingPage";   // v1.9.0 · reservas públicas
import PrivacyPage from "./pages/PrivacyPage";   // v1.19.1 · política de privacidad (la pide Meta)
import PublicDocPage from "./pages/PublicDocPage";   // v1.10.0 · cotizaciones y facturas por enlace
import AuditoriaPage from "./pages/auditoria/AuditoriaPage";   // v1.22.0 · Auditoría interna

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SiteLanding />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/transferencia" element={<TransferPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/finanzas" element={<FinanzasPage />} />
          <Route path="/finanzas/cobros" element={<FinanzasPagosPage />} />
          <Route path="/contratos" element={<ContratosPage />} />
          <Route path="/firmar/:token" element={<FirmarContratoPage />} />
          <Route path="/customer" element={<CustomerPage />} />
          <Route path="/payphone" element={<PayphonePage />} />
          <Route path="/payphone/confirmacion" element={<PayphoneConfirmacionPage />} />
          <Route path="/mercado" element={<MercadoPage />} />
          <Route path="/usuarios" element={<UsuariosPage />} />
          <Route path="/qa" element={<QAPage />} />
          <Route path="/qa/firmar-acta/:token" element={<FirmarActaPage />} />
          <Route path="/configuracion/emails" element={<EmailConfigPage />} />
          <Route path="/compras" element={<ComprasPage />} />
          <Route path="/contabilidad" element={<ContabilidadPage />} />
          {/* v1.7.0 · CRM fase 1 */}
          <Route path="/crm" element={<CrmPage />} />
          <Route path="/crm/contactos/:id" element={<CrmPage />} />
          <Route path="/auditoria" element={<AuditoriaPage />} />   {/* v1.22.0 */}
          <Route path="/privacidad" element={<PrivacyPage />} />   {/* v1.19.1 · pública */}
          <Route path="/reservar/:slug" element={<BookingPage />} />   {/* v1.9.0 · pública, sin sesión */}
          <Route path="/documento/:token" element={<PublicDocPage />} />   {/* v1.10.0 · pública, sin sesión */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
